module.exports = __webpack_public_path__ + "img/Philips.cae0b019.svg";